export const FUTURES = 'FUTURES'
export const INDEX = 'INDEX'
export const categories = ['CALL', 'PUT']
